import React from "react";

export function LogoIcon({ size = 48, className = "" }) {
  return (
    <img
      src="/cube_logo.png"
      alt="Realm Pixel Games logo"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

export function LogoText({ className = "", height = 28 }) {
  return (
    <img
      src="/text_logo.png"
      alt="Realm Pixel Games"
      height={height}
      className={className}
      style={{ objectFit: "contain", height, width: "auto" }}
    />
  );
}
